(function () {
  var FREE_SHIPPING_THRESHOLD = 6000; // $60 AUD in cents

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: currency || 'AUD'
    }).format(cents / 100);
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function renderCartDrawer(cart) {
    var drawer = document.getElementById('NomadCartDrawer');

    if (!drawer) {
      return;
    }

    var itemsContainer = drawer.querySelector('[data-nomad-cart-items]');
    var subtotal = drawer.querySelector('[data-nomad-cart-subtotal]');
    var count = drawer.querySelector('[data-nomad-cart-count]');
    var shippingMessage = drawer.querySelector('[data-nomad-shipping-message]');
    var shippingProgress = drawer.querySelector('[data-nomad-shipping-progress]');

    count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    subtotal.textContent = formatMoney(cart.total_price, cart.currency);

    var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
    var progress = Math.min(
      (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100,
      100
    );

    shippingProgress.style.width = progress + '%';

    if (remaining > 0) {
      shippingMessage.textContent =
        "🚚 You're " +
        formatMoney(remaining, cart.currency) +
        ' away from free shipping!';
    } else {
      shippingMessage.textContent = '🚚 You’ve got free shipping!';
    }

    if (!cart.items.length) {
      itemsContainer.innerHTML = '<p>Your cart is empty.</p>';
      return;
    }

    itemsContainer.innerHTML = cart.items
      .map(function (item) {
        var variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="nomad-cart-drawer__item-variant">' +
              escapeHtml(item.variant_title) +
              '</div>'
            : '';

        var image = item.image
          ? '<img src="' +
            item.image +
            '" alt="' +
            escapeHtml(item.product_title) +
            '">'
          : '';

        return (
  '<div class="nomad-cart-drawer__item">' +

    '<div class="nomad-cart-drawer__item-image">' +
      image +
    '</div>' +

    '<div class="nomad-cart-drawer__item-info">' +

      '<div class="nomad-cart-drawer__item-title">' +
        escapeHtml(item.product_title) +
      '</div>' +

      variant +

      '<div class="nomad-cart-drawer__item-unit-price">' +
        formatMoney(item.final_price, cart.currency) +
      '</div>' +

      '<div class="nomad-cart-drawer__quantity-control">' +

        '<button type="button" class="nomad-cart-drawer__quantity-btn" ' +
          'data-nomad-cart-change ' +
          'data-key="' + escapeHtml(item.key) + '" ' +
          'data-quantity="' + Math.max(item.quantity - 1, 0) + '" ' +
          'aria-label="Decrease quantity">−</button>' +

        '<span class="nomad-cart-drawer__quantity-number">' +
          item.quantity +
        '</span>' +

        '<button type="button" class="nomad-cart-drawer__quantity-btn" ' +
          'data-nomad-cart-change ' +
          'data-key="' + escapeHtml(item.key) + '" ' +
          'data-quantity="' + (item.quantity + 1) + '" ' +
          'aria-label="Increase quantity">+</button>' +

      '</div>' +

      '<button type="button" class="nomad-cart-drawer__remove" ' +
        'data-nomad-cart-change ' +
        'data-key="' + escapeHtml(item.key) + '" ' +
        'data-quantity="0">Remove</button>' +

    '</div>' +

    '<div class="nomad-cart-drawer__item-price">' +
      formatMoney(item.final_line_price, cart.currency) +
    '</div>' +

  '</div>'
);
        
      })
      .join('');

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nomad-cart-open');
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('NomadCartDrawer');

    if (!drawer) {
      return;
    }

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nomad-cart-open');
  }
function changeCartItem(key, quantity) {
  var root =
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
      ? Shopify.routes.root
      : '/';

  fetch(root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: quantity
    })
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to update cart');
      }

      return response.json();
    })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (count) {
        count.textContent = cart.item_count;
      });

      document
        .querySelectorAll('[data-cart-count-bubble]')
        .forEach(function (bubble) {
          if (cart.item_count > 0) {
            bubble.classList.remove('hide');
          } else {
            bubble.classList.add('hide');
          }
        });

      renderCartDrawer(cart);
    })
    .catch(function (error) {
      console.error('Nomad Cart Update:', error);
    });
}
 document.addEventListener('click', function (event) {
  var changeButton = event.target.closest('[data-nomad-cart-change]');

  if (changeButton) {
    event.preventDefault();

    var key = changeButton.getAttribute('data-key');
    var quantity = parseInt(
      changeButton.getAttribute('data-quantity'),
      10
    );

    changeCartItem(key, quantity);
    return;
  }

  if (event.target.closest('[data-nomad-cart-close]')) {
    closeCartDrawer();
  }
});

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeCartDrawer();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form.closest('.main-collection-section .hover-button-data')) {
      return;
    }

    if (form.getAttribute('action') !== '/cart/add') {
      return;
    }

    event.preventDefault();

    var button = form.querySelector('input[type="submit"]');
    var originalText = button ? button.value : 'Quick Add';

    if (button) {
      button.disabled = true;
      button.value = 'Adding…';
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to add product');
        }

        return response.json();
      })
      .then(function () {
        return fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (count) {
          count.textContent = cart.item_count;
        });

        document
          .querySelectorAll('[data-cart-count-bubble]')
          .forEach(function (bubble) {
            bubble.classList.remove('hide');
          });

        renderCartDrawer(cart);

        if (button) {
          button.value = 'Added ✓';

          setTimeout(function () {
            button.value = originalText;
            button.disabled = false;
          }, 1200);
        }
      })
      .catch(function (error) {
        console.error('Nomad Quick Add:', error);

        if (button) {
          button.value = 'Try again';

          setTimeout(function () {
            button.value = originalText;
            button.disabled = false;
          }, 1500);
        }
      });
  });
  document.addEventListener('click', function (event) {
  var noteButton = event.target.closest('[data-nomad-order-note]');

  if (!noteButton) {
    return;
  }

  var noteContent = document.querySelector(
    '[data-nomad-order-note-content]'
  );

  if (!noteContent) {
    return;
  }

  var isHidden = noteContent.hasAttribute('hidden');

  if (isHidden) {
    noteContent.removeAttribute('hidden');
  } else {
    noteContent.setAttribute('hidden', '');
  }

  var plus = noteButton.querySelector(
    '.nomad-cart-drawer__option-plus'
  );

  if (plus) {
  plus.textContent = isHidden ? '-' : '+';
  }
});
document.addEventListener('click', function (event) {
  var promoButton = event.target.closest('[data-nomad-promo-code]');

  if (!promoButton) {
    return;
  }

  var promoContent = document.querySelector(
    '[data-nomad-promo-code-content]'
  );

  if (!promoContent) {
    return;
  }

  var isHidden = promoContent.hasAttribute('hidden');

  if (isHidden) {
    promoContent.removeAttribute('hidden');
  } else {
    promoContent.setAttribute('hidden', '');
  }

  var plus = promoButton.querySelector(
    '.nomad-cart-drawer__option-plus'
  );

  if (plus) {
    plus.textContent = isHidden ? '-' : '+';
  }
});
document.addEventListener('click', function (event) {
  var applyButton = event.target.closest('[data-nomad-promo-apply]');

  if (!applyButton) {
    return;
  }

  var promoInput = document.querySelector('[data-nomad-promo-input]');

  if (!promoInput) {
    return;
  }

  var code = promoInput.value.trim();

  if (!code) {
    promoInput.focus();
    return;
  }

  applyButton.disabled = true;
  applyButton.textContent = 'Applying...';

  var root =
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
      ? Shopify.routes.root
      : '/';

  fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      discount: code
    })
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to apply discount code');
      }

      return response.json();
    })
    .then(function (cart) {
      renderCartDrawer(cart);

      applyButton.textContent = 'Applied ✓';

      setTimeout(function () {
        applyButton.textContent = 'Apply';
        applyButton.disabled = false;
      }, 1800);
    })
    .catch(function (error) {
      console.error('Nomad Promo Code:', error);

      applyButton.textContent = 'Try again';

      setTimeout(function () {
        applyButton.textContent = 'Apply';
        applyButton.disabled = false;
      }, 1800);
    });
});

  function saveNomadCartNote(note) {
  var status = document.querySelector('[data-nomad-note-status]');

  if (status) {
    status.textContent = 'Saving...';
  }

  var root =
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
      ? Shopify.routes.root
      : '/';

  return fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      note: note
    }),
    keepalive: true
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to save cart note');
      }

      return response.json();
    })
    .then(function (cart) {
      if (status) {
        status.textContent = 'Saved ✓';
      }

      return cart;
    })
    .catch(function (error) {
      console.error('Nomad Cart Note:', error);

      if (status) {
        status.textContent = 'Could not save — please try again';
      }
    });
}
var nomadNoteSaveTimer;

document.addEventListener('input', function (event) {
  if (!event.target.matches('[data-nomad-order-note-input]')) {
    return;
  }

  clearTimeout(nomadNoteSaveTimer);

  var note = event.target.value;

  nomadNoteSaveTimer = setTimeout(function () {
    saveNomadCartNote(note);
  }, 500);
});

document.addEventListener('focusout', function (event) {
  if (!event.target.matches('[data-nomad-order-note-input]')) {
    return;
  }

  clearTimeout(nomadNoteSaveTimer);
  saveNomadCartNote(event.target.value);
});
})();